/*
==========================================
STAMP COLLAPSE  v3.2.1
==========================================
手机端 4 步骤手风琴（Step 5 REVIEW 已移除）：
  STEP 1 PHOTO   — 默认展开
  STEP 2 TEXT    — 默认折叠
  STEP 3 BORDER  — 默认折叠
  STEP 4 SPECS   — 默认折叠

规则：点击任一步骤 header → 该步骤展开，其余全部折叠

v3.2.1 变更：
- [REMOVE] 手机端去掉 STEP 5 REVIEW（wrapStep5 直接 return）
- [FIX] accordion 展开时不再对 step 5 特殊处理 topPreview 隐藏逻辑

v3.2.0 变更：
- [FIX] 重复上传同一张图片：label click 时预先清空 input.value，确保 change 事件总触发
- [NEW] STEP 1 紧凑一行布局：[Click to Upload] [Style: A B C D] [Tools ▾] 全在一行
- [NEW] 上传后 label 显示文件名（截断），再次点击仍可替换

v3.1.0 变更：
- Border 单行布局：显示前4个选项（OFF/实线/短实线/点）
- More + Advanced 合并为一个 combo 按钮，放在同行末尾
==========================================
*/
(function () {
  'use strict';

  var FONT_VISIBLE   = 6;
  var BORDER_VISIBLE = 4;   /* ← 只显示前4个边框选项 */
  var MOBILE_BP      = 900;

  function isMobile() { return window.innerWidth <= MOBILE_BP; }

  function makeBtn(cls, text, onClick) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = cls;
    btn.textContent = text;
    btn.addEventListener('click', onClick);
    return btn;
  }

  /* ════ 1. Font More/Less ════ */
  function applyFontCollapse(picker) {
    if (!picker || picker.dataset.collapseInit) return;
    picker.dataset.collapseInit = '1';
    var box = picker.querySelector('.prod-font-options');
    if (!box) return;
    var btns = box.querySelectorAll('.prod-font-btn');
    if (btns.length <= FONT_VISIBLE) return;
    for (var i = FONT_VISIBLE; i < btns.length; i++) btns[i].classList.add('prod-font-hidden');
    var toggle = makeBtn('prod-font-toggle', 'More \u25be', function () {
      picker.classList.toggle('expanded');
      toggle.textContent = picker.classList.contains('expanded') ? 'Less \u25b4' : 'More \u25be';
    });
    box.appendChild(toggle);
  }

  /* ════ 2. Border — 前4个可见，More + Advanced 合并为一个 combo 按钮 ════ */
  function applyBorderCollapse(box) {
    if (!box || box.dataset.collapseInit) return;
    box.dataset.collapseInit = '1';

    var btns = box.querySelectorAll('.prod-border-btn');

    /* 隐藏第5个及之后的边框按钮 */
    var hasHidden = btns.length > BORDER_VISIBLE;
    for (var i = BORDER_VISIBLE; i < btns.length; i++) {
      btns[i].classList.add('prod-border-hidden');
    }

    /* 找到 Advanced 面板和原始按钮 */
    var advBtn   = document.getElementById('prodBorderAdvancedToggle');
    var advPanel = document.getElementById('prodBorderSliders');

    /* 追踪展开状态 */
    var moreOpen = false;
    var advOpen  = false;

    /* 构建 combo 按钮标签 */
    function comboLabel() {
      var morePart = hasHidden ? (moreOpen ? 'Less' : 'More') : null;
      var advPart  = advPanel  ? (advOpen  ? 'Adv \u25b4' : 'Adv \u25be') : null;
      if (morePart && advPart) return morePart + ' \u00b7 ' + advPart;
      if (morePart) return morePart + (moreOpen ? ' \u25b4' : ' \u25be');
      if (advPart)  return advPart;
      return 'Options';
    }

    /* 如果既没有隐藏按钮也没有 Advanced 面板，不生成 combo 按钮 */
    if (!hasHidden && !advPanel) return;

    var comboBtn = makeBtn('prod-border-combo-btn', comboLabel(), function () {
      /* 同时切换 More 和 Adv */
      if (hasHidden) {
        moreOpen = !moreOpen;
        box.classList.toggle('expanded', moreOpen);
      }
      if (advPanel) {
        advOpen = !advOpen;
        advPanel.style.display = advOpen ? 'flex' : 'none';
        /* 同步展开内层真正的滑块面板 prodBorderAdvancedPanel */
        var innerPanel = document.getElementById('prodBorderAdvancedPanel');
        if (innerPanel) innerPanel.style.display = advOpen ? 'flex' : 'none';
        /* 同步原始 advBtn 的激活样式（如果有其他逻辑依赖它） */
        if (advBtn) advBtn.classList.toggle('active', advOpen);
      }
      comboBtn.textContent = comboLabel();
      comboBtn.classList.toggle('prod-border-combo-btn--open', moreOpen || advOpen);
    });

    /* 把 combo 按钮追加到 border-options 容器末尾（同一行） */
    box.appendChild(comboBtn);

    /* 隐藏原始 advBtn（已被 combo 接管） */
    if (advBtn) advBtn.style.display = 'none';
  }

  /* ════ 3. Bold into slider-row ════ */
  function mergeBoldIntoRow(row) {
    if (!row || row.dataset.boldMerged) return;
    var next = row.nextElementSibling;
    if (!next || !next.classList.contains('prod-size-slider-group')) return;
    if (next.classList.contains('prod-slider-half')) return;
    if (!next.querySelector('[id*="FontWeight"],[id*="fontweight"]')) return;
    row.dataset.boldMerged = '1';
    next.style.marginTop = '';
    row.appendChild(next);
  }

  /* ════ 4. TEXT advanced: input + Style same row ════ */
  function applyTextAdvanced(group) {
    if (!group || group.dataset.advInit) return;
    var hasFontOrSlider = group.querySelector('.prod-font-picker, .prod-slider-row');
    if (!hasFontOrSlider) return;
    group.dataset.advInit = '1';

    var toWrap = [];
    Array.from(group.children).forEach(function (child) {
      if (child.classList.contains('prod-font-picker')) { toWrap.push(child); return; }
      if (child.classList.contains('prod-slider-row'))  { toWrap.push(child); return; }
      if (child.classList.contains('prod-size-slider-group') &&
          !child.classList.contains('prod-slider-half')) { toWrap.push(child); return; }
    });
    if (!toWrap.length) return;

    var panel = document.createElement('div');
    panel.className = 'prod-adv-panel';
    group.insertBefore(panel, toWrap[0]);
    toWrap.forEach(function (el) { panel.appendChild(el); });

    var advBtn = makeBtn('prod-adv-toggle', 'Style \u25be', function () {
      var open = panel.classList.toggle('prod-adv-open');
      advBtn.textContent = open ? 'Style \u25b4' : 'Style \u25be';
    });

    var textInput = group.querySelector(
      'input[type="text"].prod-text-input, input[type="text"].prod-custom-input, ' +
      'input[type="text"][id*="Line"], input[type="text"][id*="Text"]'
    );
    if (textInput) {
      var inputRow = document.createElement('div');
      inputRow.className = 'prod-input-style-row';
      textInput.parentNode.insertBefore(inputRow, textInput);
      inputRow.appendChild(textInput);
      inputRow.appendChild(advBtn);
    } else {
      var label = group.querySelector('.prod-option-label');
      if (label) {
        label.style.cssText += ';display:flex;align-items:center;justify-content:space-between';
        label.appendChild(advBtn);
      } else {
        group.insertBefore(advBtn, panel);
      }
    }
  }

  /* ════ 5. Wrap steps 1-4 ════ */
  function wrapSteps() {
    var form = document.getElementById('prodStampForm');
    if (!form || form.dataset.stepsWrapped) return;
    form.dataset.stepsWrapped = '1';

    var direct = Array.from(form.querySelectorAll(':scope > .prod-option-group'));
    var photoGroups = [], textGroups = [], borderGroups = [], specsGroups = [];

    direct.forEach(function (g) {
      if (g.querySelector('#prodPhotoUpload, .prod-style-buttons, .prod-file-input')) {
        photoGroups.push(g); return;
      }
      if (g.id === 'prodImageToolsGroup') { photoGroups.push(g); return; }
      if (g.querySelector('.prod-border-options')) { borderGroups.push(g); return; }
      if (g.querySelector('.prod-size-options, .prod-ink-options') ||
          g.classList.contains('prod-price-group-desktop')) { specsGroups.push(g); return; }
      if (g.querySelector('.prod-text-input,.prod-custom-input,.prod-font-picker,input[id*="Line"],input[id*="Text"]')) {
        textGroups.push(g); return;
      }
    });

    var imgTools = document.getElementById('prodImageToolsGroup');
    if (imgTools && photoGroups.indexOf(imgTools) === -1) {
      var p = imgTools.parentElement;
      if (p && p.classList.contains('prod-option-group') && photoGroups.indexOf(p) === -1) photoGroups.push(p);
      else if (!p || !p.classList.contains('prod-option-group')) photoGroups.push(imgTools);
    }

    wrapGroup(photoGroups,  '1', 'STEP 1 \u2014 PHOTO');
    wrapGroup(textGroups,   '2', 'STEP 2 \u2014 TEXT');
    wrapGroup(borderGroups, '3', 'STEP 3 \u2014 BORDER');
    wrapGroup(specsGroups,  '4', 'STEP 4 \u2014 SPECS');
  }

  /* ════ 6. Wrap Step 5 REVIEW ════ */
  /* v4.5.4: 手机端不再显示 STEP 5 REVIEW，直接 return */
  function wrapStep5() {
    return; // Step 5 已移除

    var previewBottom = document.querySelector('.prod-mobile-preview-bottom');
    var confirmBox    = document.querySelector('.prod-confirm-box');
    var submitBtn     = document.querySelector('.prod-submit-btn.prod-submit-btn-desktop');
    if (!previewBottom && !confirmBox) return;

    var block = document.createElement('div');
    block.className = 'prod-step-block prod-step-review';
    block.dataset.step = '5';

    var header = document.createElement('div');
    header.className = 'prod-step-header';
    header.innerHTML =
      '<span class="prod-step-badge">5</span>' +
      '<span class="prod-step-title">STEP 5 \u2014 REVIEW</span>' +
      '<span class="prod-step-summary"></span>' +
      '<span class="prod-step-chevron">\u25be</span>';
    block.appendChild(header);

    var body = document.createElement('div');
    body.className = 'prod-step-body';
    block.appendChild(body);

    if (previewBottom) {
      var parent = previewBottom.parentNode;
      parent.insertBefore(block, previewBottom);
      body.appendChild(previewBottom);
    } else if (confirmBox) {
      confirmBox.parentNode.insertBefore(block, confirmBox);
    }

    var summaryCard = document.createElement('div');
    summaryCard.className = 'prod-review-summary';
    summaryCard.id = 'prodReviewSummary';
    if (previewBottom) {
      previewBottom.insertAdjacentElement('afterend', summaryCard);
    } else {
      body.appendChild(summaryCard);
    }

    if (confirmBox) body.appendChild(confirmBox);
    if (submitBtn) {
      // Fix: 移出 form 后改为 type="button"，彻底防止 native form submit
      // 所有提交逻辑都走 stamp-ui.js 里的 handleFormSubmit（通过 form submit 事件）
      submitBtn.setAttribute('type', 'button');
      submitBtn.removeAttribute('form');
      body.appendChild(submitBtn);
    }
  }

  function wrapGroup(groups, num, title) {
    if (!groups.length || groups[0].closest('.prod-step-block')) return;
    var block = document.createElement('div');
    block.className = 'prod-step-block';
    block.dataset.step = num;
    var header = document.createElement('div');
    header.className = 'prod-step-header';
    header.innerHTML =
      '<span class="prod-step-badge">' + num + '</span>' +
      '<span class="prod-step-title">' + title + '</span>' +
      '<span class="prod-step-summary"></span>' +
      '<span class="prod-step-chevron">\u25be</span>';
    block.appendChild(header);
    var body = document.createElement('div');
    body.className = 'prod-step-body';
    block.appendChild(body);
    var parent = groups[0].parentNode;
    parent.insertBefore(block, groups[0]);
    groups.forEach(function (g) { body.appendChild(g); });
  }

  /* ════ 7. Accordion ════ */
  function initStepAccordion() {
    var blocks = Array.from(document.querySelectorAll('.prod-step-block'));
    if (!blocks.length) return;

    function collapseBlock(block) {
      block.classList.add('step-collapsed');
      var ch = block.querySelector('.prod-step-chevron');
      if (ch) ch.textContent = '\u25b8';
      refreshSummary(block);
    }
    function expandBlock(block) {
      block.classList.remove('step-collapsed');
      var ch = block.querySelector('.prod-step-chevron');
      if (ch) ch.textContent = '\u25be';
    }

    if (isMobile()) {
      blocks.forEach(function (b) {
        if (b.dataset.step === '1') expandBlock(b);
        else collapseBlock(b);
      });
    }

    var topPreview = document.querySelector('.prod-mobile-preview-top');

    function setTopPreview(visible) {
      if (!topPreview) return;
      if (visible) topPreview.classList.remove('prod-preview-top--hidden');
      else         topPreview.classList.add('prod-preview-top--hidden');
    }

    blocks.forEach(function (block) {
      var header = block.querySelector('.prod-step-header');
      if (!header) return;
      header.addEventListener('click', function () {
        if (!isMobile()) return;
        var isCollapsed = block.classList.contains('step-collapsed');
        if (isCollapsed) {
          blocks.forEach(function (b) {
            b === block ? expandBlock(b) : collapseBlock(b);
          });
          setTopPreview(true);
        } else {
          collapseBlock(block);
          setTopPreview(true);
        }
      });
    });

    function refreshSummary(block) {
      var el = block.querySelector('.prod-step-summary');
      if (!el) return;
      var step = block.dataset.step, parts = [];
      if (step === '1') {
        // ★ Fix: 用 prodPhotoUploaded 判断，兼容所有布局（image-left/image-top/curved-text等）
        // 原来只查 block 内的 .prod-photo-preview-area img，image-left等布局该元素不在block内，永远显示 No photo
        var uploaded = document.getElementById('prodPhotoUploaded');
        if (uploaded && uploaded.value === 'Yes') {
          parts.push('\u2705 Ready');
        } else {
          // 降级：在全局预览区查找各种布局的照片元素
          var anyImg = document.querySelector('#prodStampCanvas .prod-photo-preview-area img') ||
                       document.querySelector('#prodStampCanvas .prod-illustration-left img.prod-illustration-img') ||
                       document.querySelector('#prodStampCanvas .prod-illustration-top img.prod-illustration-img') ||
                       document.querySelector('#prodStampCanvas .prod-illustration-center.prod-photo-preview img');
          parts.push(anyImg && anyImg.src && anyImg.src.length > 50 ? '\u2705 Ready' : 'No photo');
        }
      } else if (step === '2') {
        block.querySelectorAll('input[type="text"]').forEach(function (inp) {
          if (inp.value.trim()) parts.push(inp.value.trim());
        });
        if (!parts.length) parts.push('No text');
      } else if (step === '3') {
        var ab = block.querySelector('.prod-border-btn.active');
        parts.push(ab ? (ab.dataset.border === 'none' ? 'None' : (ab.title || ab.dataset.border)) : 'None');
      } else if (step === '4') {
        var sb = block.querySelector('.prod-size-btn.active');
        var ib = block.querySelector('.prod-ink-btn.active');
        if (sb) parts.push(sb.textContent.trim());
        if (ib) parts.push(ib.textContent.trim());
      } else if (step === '5') {
        parts.push('Check your stamp');
      }
      el.textContent = parts.join(' \u00b7 ');
    }

    blocks.forEach(function (block) {
      block.addEventListener('input', function () { refreshSummary(block); });
    });

    function buildReviewCard() {
      var card = document.getElementById('prodReviewSummary');
      if (!card) return;
      var rows = [];

      document.querySelectorAll('.prod-step-block[data-step="2"] input[type="text"]')
        .forEach(function (inp) {
          var label = inp.closest('.prod-option-group');
          var labelEl = label ? label.querySelector('.prod-option-label') : null;
          var name = labelEl ? labelEl.textContent.trim() : '';
          if (inp.value.trim()) rows.push({ name: name, value: inp.value.trim() });
        });

      var ab = document.querySelector('.prod-step-block[data-step="3"] .prod-border-btn.active');
      if (ab) rows.push({ name: 'Border', value: ab.dataset.border === 'none' ? 'None' : (ab.title || ab.dataset.border) });

      var sb = document.querySelector('.prod-step-block[data-step="4"] .prod-size-btn.active');
      var ib = document.querySelector('.prod-step-block[data-step="4"] .prod-ink-btn.active');
      if (sb) rows.push({ name: 'Size', value: sb.textContent.trim() });
      if (ib) rows.push({ name: 'Ink', value: ib.textContent.trim() });

      card.innerHTML = rows.map(function (r) {
        return '<div class="prod-review-row">' +
          '<span class="prod-review-key">' + r.name + '</span>' +
          '<span class="prod-review-val">' + r.value + '</span>' +
          '</div>';
      }).join('');
    }

    blocks.forEach(function (block) {
      if (block.dataset.step !== '5') return;
      var header = block.querySelector('.prod-step-header');
      if (header) header.addEventListener('click', function () {
        setTimeout(buildReviewCard, 50);
      });
    });

    document.addEventListener('input', function () {
      if (document.querySelector('.prod-step-block[data-step="5"]:not(.step-collapsed)')) {
        buildReviewCard();
      }
    });
    document.addEventListener('click', function (e) {
      if (e.target.closest('.prod-font-btn,.prod-border-btn,.prod-style-btn,.prod-size-btn,.prod-ink-btn')) {
        setTimeout(function () {
          if (document.querySelector('.prod-step-block[data-step="5"]:not(.step-collapsed)')) {
            buildReviewCard();
          }
        }, 50);
      }
    });
  }

  /* ════ 8. Photo block restructure  v3.2.0 ════ */
  function restructurePhotoBlock() {
    var realInput = document.getElementById('prodPhotoUpload');
    if (!realInput) return;
    var uploadGroup = realInput.closest('.prod-option-group');
    if (!uploadGroup || uploadGroup.dataset.photoInit) return;
    uploadGroup.dataset.photoInit = '1';

    var label     = uploadGroup.querySelector('.prod-option-label');
    var fileWrap  = uploadGroup.querySelector('.prod-file-input-wrapper');
    var hint      = uploadGroup.querySelector('.prod-file-hint');
    var styleOpts = uploadGroup.querySelector('.prod-style-options');
    var styleBtns = uploadGroup.querySelector('.prod-style-buttons');
    var sublabel  = uploadGroup.querySelector('.prod-option-sublabel');

    /* ── 隐藏原始 DOM ── */
    if (label)    label.style.display    = 'none';
    if (fileWrap) fileWrap.style.display = 'none';
    if (hint)     hint.style.display     = 'none';

    /* ── 把 input 藏到文档中，保留功能 ── */
    realInput.style.cssText = 'position:absolute;opacity:0;width:0;height:0;pointer-events:none;';

    /* ★ v3.2.0 FIX: 点 label 前先清空 value，确保选同一张图也能触发 change */
    realInput.addEventListener('click', function () {
      realInput.value = '';
    });

    /* ── 上传按钮（点击后触发 realInput） ── */
    var uploadBtn = document.createElement('button');
    uploadBtn.type = 'button';
    uploadBtn.className = 'prod-photo-upload-btn';
    uploadBtn.innerHTML = '<span class="prod-photo-upload-icon">&#128247;</span>' +
                          '<span class="prod-photo-upload-text">Click to Upload</span>';
    uploadBtn.addEventListener('click', function () {
      realInput.value = '';   /* 再次清空，双保险 */
      realInput.click();
    });

    /* 上传成功后更新按钮文字 */
    realInput.addEventListener('change', function () {
      if (realInput.files && realInput.files[0]) {
        var name = realInput.files[0].name;
        var short = name.length > 20 ? name.slice(0, 17) + '...' : name;
        uploadBtn.querySelector('.prod-photo-upload-text').textContent = short;
        uploadBtn.classList.add('prod-photo-upload-btn--done');
      }
    });

    /* ── Style 按钮缩写 A B C D ── */
    var styleRow = null;
    if (styleBtns) {
      var btns = styleBtns.querySelectorAll('.prod-style-btn');
      ['A','B','C','D'].forEach(function (ltr, i) {
        if (!btns[i]) return;
        btns[i].dataset.fullLabel = btns[i].textContent.trim();
        btns[i].textContent = ltr;
        btns[i].title = btns[i].dataset.fullLabel;
        btns[i].classList.add('prod-style-btn--compact');
      });

      if (sublabel) sublabel.textContent = 'Style:';

      /* Tools 按钮 */
      var toolsGroup = document.getElementById('prodImageToolsGroup');
      var toolsBtn = makeBtn('prod-photo-tools-btn', 'Tools \u25be', function () {
        if (!toolsGroup) return;
        var open = toolsGroup.classList.toggle('prod-tools-open');
        toolsBtn.textContent = open ? 'Tools \u25b4' : 'Tools \u25be';
      });

      /* ── 第二行：Style: [A][B][C][D] [Tools▾] ── */
      styleRow = document.createElement('div');
      styleRow.className = 'prod-photo-style-row';
      if (sublabel) styleRow.appendChild(sublabel);
      styleRow.appendChild(styleBtns);
      styleRow.appendChild(toolsBtn);

      if (styleOpts) styleOpts.style.display = 'none';
      if (toolsGroup) toolsGroup.classList.add('prod-tools-panel');
    }

    /* ── 插入 DOM ── */
    /* 第一行：[📷 Click to Upload] */
    uploadGroup.insertBefore(uploadBtn, label);
    /* 第二行：[Style: A B C D] [Tools▾] */
    if (styleRow) uploadGroup.insertBefore(styleRow, label);

    /* Image Size slider（由 stamp-ui.js 的 _relocatePhotoSizeSlider 注入）
       已经在 uploadBtn 之后自动排列，不需要额外处理 */
  }

  /* ════ Main init ════ */
  function init() {
    document.querySelectorAll('.prod-slider-row').forEach(mergeBoldIntoRow);
    document.querySelectorAll('.prod-option-group').forEach(applyTextAdvanced);
    document.querySelectorAll('.prod-font-picker').forEach(applyFontCollapse);
    document.querySelectorAll('.prod-border-options').forEach(applyBorderCollapse);
    wrapSteps();
    if (isMobile()) {
      wrapStep5();
      restructurePhotoBlock();
    }
    initStepAccordion();

    // ★ v4.5.3: address-label STEP 5 预览图延迟同步
    // 在 wrapStep5 完成后，即刻 + 延迟触发 _alStep5Update
    if (isMobile()) {
      [0, 400, 1000, 2000].forEach(function(ms) {
        setTimeout(function() {
          if (typeof window._alStep5Update === 'function') window._alStep5Update();
        }, ms);
      });
    }

    // ★ v4.5.2: stickyBtn 唯一入口
    // address-label 有自己的 submitOrder() 流程，不能走 StampUI.handleFormSubmit
    var stickyBtn = document.getElementById('prodStickyBarBtn');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var cfg = {};
        try {
          var cfgEl = document.getElementById('prodStampConfig');
          if (cfgEl) cfg = JSON.parse(cfgEl.textContent || '{}');
        } catch (_) {}
        if (cfg.layout === 'address-label') {
          if (window.StampAddressComposer &&
              typeof window.StampAddressComposer.submitOrder === 'function') {
            window.StampAddressComposer.submitOrder();
          }
        } else {
          if (window.StampUI && typeof window.StampUI.handleFormSubmit === 'function') {
            window.StampUI.handleFormSubmit(e);
          }
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.StampCollapse = {
    init: init,
    // Fix: call after photo upload to refresh Step 1 summary
    refreshStep1: function () {
      var block = document.querySelector('.prod-step-block[data-step="1"]');
      if (block) refreshSummary(block);
    }
  };
})();